import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";

// Lazy load all page components for code splitting
const Login = lazy(() => import("pages/login"));
const SalesDashboard = lazy(() => import("pages/sales-dashboard"));
const DealManagement = lazy(() => import("pages/deal-management"));
const ContactManagement = lazy(() => import("pages/contact-management"));
const PipelineAnalytics = lazy(() => import("pages/pipeline-analytics"));
const ActivityTimeline = lazy(() => import("pages/activity-timeline"));
const SettingsAdministration = lazy(() => import("pages/settings-administration"));

// Loading component
const Loading = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Suspense fallback={<Loading />}>
          <RouterRoutes>
            <Route path="/login" element={<Login />} />
            <Route path="/sales-dashboard" element={<SalesDashboard />} />
            <Route path="/deal-management" element={<DealManagement />} />
            <Route path="/contact-management" element={<ContactManagement />} />
            <Route path="/pipeline-analytics" element={<PipelineAnalytics />} />
            <Route path="/activity-timeline" element={<ActivityTimeline />} />
            <Route path="/settings-administration" element={<SettingsAdministration />} />
            <Route path="/" element={<SalesDashboard />} />
          </RouterRoutes>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;